// Each surface declares what it supports so the workspace/header gate behavior on
// these flags, not the data source. Mentor live is the only surface wired today.
export interface AttentionSurfaceCapabilities {
  canCompose: boolean;
  canReact: boolean;
  canPerformHeaderActions: boolean;
}

export const MENTOR_LIVE_CAPABILITIES: AttentionSurfaceCapabilities = {
  canCompose: true,
  canReact: true,
  canPerformHeaderActions: true,
};

export const ADMIN_READONLY_CAPABILITIES: AttentionSurfaceCapabilities = {
  canCompose: false,
  canReact: false,
  canPerformHeaderActions: false,
};
